import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import SeeMoreLink from '@ep/components/SeeMoreLink';
import { H3, Subhead2 } from '@ep/components/Typography';
import icons from '@ep/images/icons';
import theme from '@ep/theme';
import { Gcms_RichText } from '@ep/types/gatsbyTypes';
import getHtmlProp from '@ep/utils/getHtmlProp';
import { alpha as fade } from '@mui/material/styles';
import React from 'react';

export interface BannerModuleProps {
  icon: string;
  heading: string;
  subheading?: Gcms_RichText;
  alignLeft?: boolean;
  buttonLabel?: string;
  buttonLink?: string;
  backgroundColor: string;
  color?: string;
}

const StyledContainer = styled(Container)<BannerModuleProps>`
  padding: 3.75rem 0 4.5rem;
  text-align: center;
  ${({ alignLeft }) =>
    alignLeft ? `text-align: left;` : `text-align: center;`}
  ${({ color }) => (color ? `color: ${color};` : undefined)}
  h3 {
    ${({ color }) => (color ? `color: ${color};` : undefined)}
  }
  > svg {
    width: 5.5rem;
    height: 5.5rem;
  }

  ${theme.mediaQueries.tablet} {
    padding: 5rem 0;
  }
`;

const Heading = styled(H3)`
  margin: 1.5rem 0;
  width: 65%;
  margin: 1.5rem auto;
`;

const SubHeading = styled(Subhead2)`
  margin: 1.5rem 0;
  width: 75%;
  margin: 1.5rem auto;
`;

const StyledSeeMoreLink = styled(SeeMoreLink)`
  margin-top: 1rem;
  color: inherit;
`;

function BannerModule({
  icon,
  heading,
  subheading,
  alignLeft,
  buttonLabel,
  buttonLink,
  backgroundColor,
  color,
}: BannerModuleProps) {
  var hasIcon = false;
  var Icon = false;

  if (icon) {
    Icon = icons[icon as keyof typeof icons];
    hasIcon = true;
  }

  return (
    <StyledContainer
      backgroundColor={backgroundColor}
      color={color}
      alignLeft={alignLeft}
    >
      {hasIcon && <Icon />}
      <Heading>{heading}</Heading>
      {subheading && <SubHeading {...getHtmlProp(subheading.html)} />}
      {buttonLabel && buttonLink && (
        <StyledSeeMoreLink label={buttonLabel} to={buttonLink} />
      )}
    </StyledContainer>
  );
}

BannerModule.defaultProps = {
  backgroundColor: fade(theme.colors.lightBlue, 0.15),
};

export default React.memo(BannerModule);
